export default [
    { path: "/20136556/shoshke_1", id: "div-gpt-ad-23025992426" },
    { path: "/20136556/shoshke_2", id: "div-gpt-ad-23025995417" },
    { path: "/20136556/shoshke_3", id: "div-gpt-ad-23025983771" },
    { path: "/20136556/shoshke_4", id: "div-gpt-ad-23025424555" },
    { path: "/20136556/shoshke_5", id: "div-gpt-ad-23025983780" },
    { path: "/20136556/shoshke_6", id: "div-gpt-ad-23025996608" },
    { path: "/20136556/shoshke_7", id: "div-gpt-ad-23025996974" },
    { path: "/20136556/shoshke_8", id: "div-gpt-ad-23025425395" },
    { path: "/20136556/shoshke_9", id: "div-gpt-ad-23025425635" },
    { path: "/20136556/shoshke_10", id: "div-gpt-ad-23025129789" },
    { path: "/20136556/shoshke_11", id: "div-gpt-ad-23025129360" },
    { path: "/20136556/shoshke_12", id: "div-gpt-ad-23025997940" },
    { path: "/20136556/shoshke_13", id: "div-gpt-ad-23025426415" },
    { path: "/20136556/shoshke_14", id: "div-gpt-ad-23025998402" },
    { path: "/20136556/shoshke_15", id: "div-gpt-ad-23025998549" },
    { path: "/20136556/600x400_bonakir", id: "div-gpt-ad-1651067781430-0" },
    { path: "/20136556/600x400_bonakir_1", id: "div-gpt-ad-1666081826256-0" },
    { path: "/20136556/600x400_bonakir_2", id: "div-gpt-ad-1666081897362-0" },
    { path: "/20136556/600x400_bonakir_3", id: "div-gpt-ad-1666081936078-0" },
    { path: "/20136556/600x400_bonakir_4", id: "div-gpt-ad-1666081963895-0" }]